<!--
 * @Description: 单票下单
 * @Author: ganjia
 * @Date: 2019-10-15 14:10:50
 -->
<template>
  <div class="main-wrap singleOrder">
    <el-form class="el-form-edit" ref="sizeForm" :rules="rules" :inline="true" :model="formData" label-position="left" label-suffix=":" label-width="80px">
      <el-row :gutter="24">
        <el-col :span="12">
          <h3>{{ $lang('寄件人信息') }}</h3>
          <div class="group-content">
            <el-form-item :label="$lang('姓名')" prop="senderName">
              <el-autocomplete
                valueKey="name"
                v-model="formData.senderName"
                @select="changeSenderName"
                :fetch-suggestions="remoteSenderName"
                :placeholder="$lang('请输入寄件人姓名')"
              >
                <template slot="suffix">
                  <i class="iconfont icondizhibao pointer" @click="open(1)"></i>
                </template>
              </el-autocomplete>
            </el-form-item>
            <el-form-item :label="$lang('联系电话')" prop="senderMobilePhone">
              <template slot="label"
                ><span :title="$lang('联系电话')">{{ $lang('联系电话') }}</span></template
              >
              <el-autocomplete
                valueKey="mobile"
                @select="changeSenderName"
                v-model="formData.senderMobilePhone"
                :fetch-suggestions="remoteSenderMobilePhone"
                :placeholder="$lang('请输入寄件人联系电话')"
                :minlength="10"
                :maxlength="13"
              >
              </el-autocomplete>
            </el-form-item>
            <el-form-item :label="$lang('公司名称')" prop="senderCompany">
              <template slot="label"
                ><span :title="$lang('公司名称')">{{ $lang('公司名称') }}</span></template
              >
              <el-input v-model="formData.senderCompany" :placeholder="$lang('请输入公司名称')" :minlength="1" :maxlength="30" />
            </el-form-item>
            <el-form-item :label="$lang('省/市/区')" prop="senderProvince" class="w160">
              <BaseAddress
                ref="senderProvinceSearch"
                :initAddressData="sendAddressData"
                :showLevel="3"
                v-model="formData.senderProvince"
                @changeValue="senderchangeValue"
              ></BaseAddress>
              <el-tooltip effect="dark" placement="bottom">
                <span class="tooltip-click">?</span>
                <div slot="content">
                  {{ $lang('区域无法选择？') }}<br />
                  {{ $lang('存在区域未开通，暂无法服务') }}
                </div>
              </el-tooltip>
            </el-form-item>
            <el-form-item class="el-form-item el-form-item--small" :label="$lang('邮编')" prop="senderPostalCode">
              <el-input v-model="formData.senderPostalCode" :placeholder="$lang('请输入邮编')" :maxlength="5" @input="changeAddress($event, 1)"></el-input>
            </el-form-item>
            <el-form-item class="el-form-item w360 el-form-item--small" :label="$lang('详细地址')" prop="senderDetailedAddress">
              <el-input v-model="formData.senderDetailedAddress" :placeholder="$lang('请填写寄件人所在街道以及详细地址')" :minlength="1" :maxlength="150"></el-input>
              <el-checkbox v-model="checkSenderFlag" style="margin-left: 15px">{{ $lang('保存至地址簿') }}</el-checkbox>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <h3>{{ $lang('收件人信息') }}</h3>
          <div class="group-content">
            <el-form-item :label="$lang('姓名')" prop="receiverName">
              <el-autocomplete
                valueKey="name"
                v-model="formData.receiverName"
                @select="changeReceiverName"
                :fetch-suggestions="remoteReceiverName"
                :placeholder="$lang('请输入收件人姓名')"
              >
                <template slot="suffix">
                  <i class="iconfont icondizhibao pointer" @click="open(2)"></i>
                </template>
              </el-autocomplete>
            </el-form-item>
            <el-form-item :label="$lang('联系电话')" prop="receiverMobilePhone">
              <template slot="label"
                ><span :title="$lang('联系电话')">{{ $lang('联系电话') }}</span></template
              >
              <!-- <el-input v-model="formData.receiverMobilePhone" :maxlength='15'  :placeholder="$lang('请输入收件人联系电话')"></el-input> -->
              <el-autocomplete
                valueKey="mobile"
                @select="changeReceiverName"
                v-model="formData.receiverMobilePhone"
                :fetch-suggestions="remoteReceiverMobilePhone"
                :placeholder="$lang('请输入收件人联系电话')"
                :minlength="10"
                :maxlength="13"
              >
              </el-autocomplete>
            </el-form-item>
            <el-form-item :label="$lang('公司名称')" prop="receiverCompany">
              <template slot="label"
                ><span :title="$lang('公司名称')">{{ $lang('公司名称') }}</span></template
              >
              <el-input v-model="formData.receiverCompany" :placeholder="$lang('请输入公司名称')" :minlength="1" :maxlength="30" />
            </el-form-item>
            <el-form-item :label="$lang('省/市/区')" prop="receiverProvince" class="w160">
              <BaseAddress
                ref="receiverProvinceSearch"
                :initAddressData="receiverAddressData"
                :showLevel="3"
                v-model="formData.receiverProvince"
                @changeValue="receiverchangeValue"
              >
              </BaseAddress>
              <el-tooltip effect="dark" placement="bottom">
                <span class="tooltip-click">?</span>
                <div slot="content">
                  {{ $lang('区域无法选择？') }}<br />
                  {{ $lang('存在区域未开通，暂无法服务') }}
                </div>
              </el-tooltip>
            </el-form-item>
            <el-form-item class="el-form-item el-form-item--small" :label="$lang('邮编')" prop="receiverPostalCode">
              <el-input v-model="formData.receiverPostalCode" :placeholder="$lang('请输入邮编')" :maxlength="5" @input="changeAddress($event, 2)"></el-input>
            </el-form-item>
            <el-form-item class="el-form-item el-form-item--small w360" :label="$lang('详细地址')" prop="receiverDetailedAddress">
              <el-input v-model="formData.receiverDetailedAddress" :placeholder="$lang('请填写收件人所在街道以及详细地址')" :minlength="1" :maxlength="150"></el-input>
              <el-checkbox v-model="checkReceiverFlag" style="margin-left: 15px">{{ $lang('保存至地址簿') }}</el-checkbox>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-if="transferVisible">
        <h3>{{ $lang('退转件人信息') }}</h3>
        <div class="group-content">
          <el-form-item :label="$lang('姓名')" prop="transferName">
            <el-autocomplete
              valueKey="name"
              v-model="formData.transferName"
              @select="changeTransferName"
              :fetch-suggestions="remoteTransferName"
              :placeholder="$lang('请输入退转件人姓名')"
            >
              <template slot="suffix">
                <i class="iconfont icondizhibao pointer" @click="open(3)"></i>
              </template>
            </el-autocomplete>
          </el-form-item>
          <el-form-item :label="$lang('联系电话')" prop="transferMobilePhone">
            <el-input v-model="formData.transferMobilePhone" autocomplete="off" auto-complete="new-password" :placeholder="$lang('请输入退转件联系电话')"></el-input>
          </el-form-item>
          <el-form-item :label="$lang('公司名称')" prop="transferCompany">
            <el-input v-model="formData.transferCompany" autocomplete="off" auto-complete="new-password" :placeholder="$lang('请输入退转件公司名称')"></el-input>
          </el-form-item>
          <el-form-item :label="$lang('省/市/区')" prop="transferProvince" class="w160">
            <BaseAddress ref="transferProvinceSearch" :initAddressData="transferData" :showLevel="3" v-model="formData.transferProvince" @changeValue="changeValue"> </BaseAddress>
            <el-tooltip effect="dark" placement="bottom">
              <span class="tooltip-click">?</span>
              <div slot="content">
                {{ $lang('区域无法选择？') }}<br />
                {{ $lang('存在区域未开通，暂无法服务') }}
              </div>
            </el-tooltip>
          </el-form-item>
          <el-form-item class="el-form-item el-form-item--small" :label="$lang('邮编')" prop="transferPostalCode">
            <el-input v-model="formData.transferPostalCode" :placeholder="$lang('请输入邮编')" :maxlength="5" @input="changeAddress($event, 3)"></el-input>
          </el-form-item>
          <el-form-item style="width: 550px" class="el-form-item el-form-item--small" :label="$lang('详细地址')" prop="senderDetailedAddress">
            <el-col :span="15">
              <el-input
                autosize
                v-model="formData.transferDetailedAddress"
                :placeholder="$lang('请填写寄件人所在街道以及详细地址')"
                :minlength="1"
                style="width: 300px"
                :maxlength="150"
              ></el-input>
            </el-col>
            <el-col :span="5">
              <el-checkbox v-model="checkTransferFlag" style="margin-left: 15px">{{ $lang('保存至地址簿') }}</el-checkbox>
            </el-col>
          </el-form-item>
          <!--          <el-form-item class="w180" :label="$lang('详细地址')" prop="transferCompany">-->
          <!--            <el-input v-model="formData.transferDetailedAddress" :placeholder="$lang('请填写收件人所在街道以及详细地址')" :minlength="1" :maxlength="150"></el-input>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item :label="$lang('')" prop="transferCompany">-->
          <!--            <el-checkbox v-model="checkTransferFlag" style="margin-left:15px">{{ $lang('保存至地址簿') }}</el-checkbox>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item class="el-form-item el-form-item&#45;&#45;small w360" :label="$lang('详细地址')" prop="transferDetailedAddress">-->
          <!--            -->
          <!--            -->
          <!--          </el-form-item>-->
        </div>
      </el-row>
      <el-row>
        <el-col :span="24">
          <h3>{{ $lang('货物信息') }}</h3>
          <div class="group-content">
            <el-form-item :label="$lang('客户订单号')" prop="customerOrderId">
              <template slot="label">
                <span :title="$lang('客户订单号')">{{ $lang('客户订单号') }}</span></template
              >
              <el-input v-model="formData.customerOrderId" :placeholder="$lang('请输入')" :minlength="1" :maxlength="50"></el-input>
            </el-form-item>
            <!-- 新增计算功能 -->

            <el-tooltip effect="dark" :content="$lang('长*宽*高*件数，cm')" placement="top-start">
              <el-form-item class="dimensional-info" :label="$lang('长*宽*高*件数，cm')" prop="dimensionalInfo" label-width="185px">
                <template slot="label">
                  <span :title="$lang('长*宽*高*件数，cm')">{{ $lang('长*宽*高*件数，cm') }}</span></template>
                <el-button type="primary" @click="dimensionalInfoVisible = true" icon="el-icon-plus">{{$lang('点击添加信息')}}</el-button>
              </el-form-item>
            </el-tooltip>

            <el-form-item :label="$lang('总件数')" prop="packageNumber">
              <el-input-number v-model="formData.packageNumber" :disabled="packageNumberVolumeDisabled" :label="$lang('描述文字')" :min="1" :max="999" step-strictly @change="packageNumberChange"></el-input-number>
            </el-form-item>

            <el-form-item :label="$lang('总体积(m³)')" prop="packageTotalVolume">
              <el-input-number v-model="formData.packageTotalVolume" :disabled="packageNumberVolumeDisabled" :min="0.001" :precision="3" :max="99.999" @change="countWeightTotal"></el-input-number>
            </el-form-item>
            <el-form-item :label="$lang('物品重量(kg)')" prop="packageTotalWeight">
              <el-input-number v-model="formData.packageTotalWeight" @change="getupStairsValue" :label="$lang('描述文字')" :precision="2" :min="0" :max="99999.9"></el-input-number>
            </el-form-item>
            <el-form-item :label="$lang('支付方式')" prop="payment">
              <Base-Select
                v-model="formData.payment"
                :props="{ label: 'name', value: 'code', res: 'appPaymentMannerVOList', valueObj: true }"
                dicUrl="/vip/baseData/list"
                :placeholder="$lang('请选择')"
                :disabled="settlementId==319"
              >
              </Base-Select>
              <!-- <Base-Select v-model="formData.payment" :dic="payTypesDic" :placeholder="$lang('请选择')"  :props="{label:'name' ,value:'code',valueObj:true}"></Base-Select> -->
            </el-form-item>
            <el-form-item :label="$lang('快递类型')" prop="expressType">
              <el-select v-model="formData.expressType" @change="expressTypeChange" :placeholder="$lang('请选择')" @focus="getProductType">
                <el-option v-for="(item, index) in appProductTypeVOList" :key="index" :label="item.name" :value="item.code"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('物品类型')" prop="goods" ref="goods">
              <Base-Select
                @change="getupStairsValue"
                v-model="formData.goods"
                :props="{ label: 'name', value: 'code', res: 'appArticleTypeVOList', valueObj: true }"
                dicUrl="/vip/baseData/list"
                :placeholder="$lang('请选择')"
              >
              </Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('物品名称')" prop="goodsName">
              <el-input v-model="formData.goodsName" :placeholder="$lang('请输入')" :minlength="1" :maxlength="20"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('总体积重(kg)')">
              <el-input v-model="formData.packateVolume" disabled :min="0.0" :precision="2" :max="99999.9"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('计费重量(kg)')">
              <el-input v-model="formData.packageChargeWeight" disabled :precision="2" :min="1.0" :max="99999.9"></el-input>
            </el-form-item>

            <el-form-item :label="$lang('是否保价')" prop="insured" class="insured-info">
              <Base-Select
                :clearable="false"
                v-model="formData.insured"
                :dic="insuredDic"
                :placeholder="$lang('请选择')"
                :disabled="formData.goodsTypeCode === 'bm000001' || formData.paymentModeCode === 'CC_CASH' || this.insuranceFlag === 1"
                @change="changeInsured"
                :props="{ label: 'name', value: 'code' }"
              ></Base-Select>
              <!-- <a class="btn-insured" @click="openInsured">{{ $lang('保价声明') }}</a> -->
            </el-form-item>
            <el-form-item :label="$lang('保价金额')" prop="declaredValue" v-show="formData.insured === 1" class="declaredValue">
              <el-input-number
                v-model="formData.declaredValue"
                :placeholder="$lang('请输入')"
                :step="1"
                :precision="2"
                :controls="false"
                :min="0"
                :max="200000000"
              ></el-input-number>
            </el-form-item>
            <el-form-item :label="$lang('保价费')" prop="insuredValue" v-show="formData.insured === 1">
              <el-input v-model="formData.insuredValue" :placeholder="$lang('请输入')" :disabled="true"></el-input>
            </el-form-item>
            <!-- 是否签回单  :disabled="formData.paymentModeName === 'PP_PM' "-->
            <el-form-item :label="$lang('是否签回单')" prop="signReceipt">
              <template slot="label">
                <span :title="$lang('是否签回单')">{{ $lang('是否签回单') }}</span></template
              >
              <Base-Select
                :clearable="false"
                v-model="formData.signReceipt"
                :dic="signReceiptDic"
                :placeholder="$lang('请选择')"
                :disabled="isReceiptFlag === 0"
                @change="changeSignReceipt"
                :props="{ label: 'name', value: 'code' }"
              >
              </Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('参考运费')" prop="standardValue" v-if="userInfo.freightStatus === 1">
              <el-input v-model="formData.standardValue" :placeholder="$lang('请输入')" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item :label="$lang('回单管理费')" prop="receiptFreight" v-show="formData.signReceipt === 1">
              <el-input v-model="formData.receiptFreight" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('回单类型')" prop="receiptFreight" v-show="formData.signReceipt === 1">
              <el-input v-model="formData.receiptBusinessName" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('是否代收货款')" v-show="showCollectionfee">
              <template slot="label">
                <span :title="$lang('是否代收货款')">{{ $lang('是否代收货款') }}</span></template
              >
              <Base-Select
                :clearable="false"
                v-model="formData.isCollectionfee"
                :dic="collectionfeeDic"
                :placeholder="$lang('请选择')"
                @change="changeCollectionfee"
                :props="{ label: 'name', value: 'code' }"
              >
              </Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('代收货款金额')" class="declaredValue" v-show="showCollectionfee">
              <template slot="label">
                <span :title="$lang('代收货款金额')">{{ $lang('代收货款金额') }}</span></template
              >
              <el-input-number
                v-model="formData.collectionfee"
                :disabled="formData.isCollectionfee!=1"
                :placeholder="$lang('请输入')"
                :step="1"
                :precision="2"
                :controls="false"
                :min="0"
                :max="200000000"
                @blur="blurCollectionfee"
              ></el-input-number>
            </el-form-item>
            <el-form-item :label="$lang('代收货款手续费')" class="declaredValue" v-show="showCollectionfee">
              <template slot="label">
                <span :title="$lang('代收货款手续费')">{{ $lang('代收货款手续费') }}</span></template
              >
              <el-input-number
              :disabled="true"
                v-model="formData.collectionfeeTax"
                :placeholder="$lang('请输入')"
                :step="1"
                :precision="2"
                :controls="false"
                :min="0"
                :max="200000000"
              ></el-input-number>
            </el-form-item>
            <!-- <el-form-item :label="$lang('退转件指定地点')" prop="receiptFreight">
              <template slot="label">
                <span :title="$lang('退转件指定地点')">{{ $lang('退转件指定地点') }}</span></template
              >
              <Base-Select
                :clearable="false"
                v-model="formData.ifTransfer"
                :dic="transferDic"
                :placeholder="$lang('请选择')"
                @change="changeTransfer"
                :props="{ label: 'name', value: 'code' }"
              >
              </Base-Select>
            </el-form-item> -->

            <!-- <el-form-item :label="$lang('是否上楼')">
              <Base-Select
                :clearable="false"
                v-model="formData.isUpstairs"
                :dic="signReceiptDic"
                :placeholder="$lang('请选择')"
                @change="getupStairsValue"
                :props="{ label: 'name', value: 'code' }"
              >
              </Base-Select>
            </el-form-item> -->
            <el-form-item :label="$lang('是否电梯')" prop="isElevator" v-if="formData.isUpstairs === 1">
              <Base-Select
                :clearable="false"
                v-model="formData.isElevator"
                :dic="elevatorDic"
                :placeholder="$lang('请选择')"
                @change="getupStairsValue"
                :props="{ label: 'name', value: 'code' }"
              >
              </Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('上楼费')" v-if="formData.isUpstairs === 1">
              <el-input v-model="formData.upStairsValue" :placeholder="$lang('请输入')" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('总运费')">
              <el-input v-model="totalFreight" :placeholder="$lang('请输入')" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$lang('是否齐套配送')" prop="completeDelivery" v-if="formData.packageNumber && formData.packageNumber > 1">
              <Base-Select
                :clearable="false"
                v-model="formData.completeDelivery"
                :dic="completeDeliveryDic"
                :placeholder="$lang('请选择')"
                :props="{ label: 'name', value: 'code' }"
              ></Base-Select>
            </el-form-item>
            <!-- <el-form-item :label="$lang('服务税')">
              <el-input v-model="taxes" :placeholder="$lang('请输入')" disabled></el-input>
            </el-form-item> -->
            <br />
            <el-form-item :label="$lang('备注')" prop="remarks" class="el-form-item el-form-item--small" style="width: 50%">
              <el-input v-model="formData.remarks" :placeholder="$lang('请输入')" type="textarea" :rows="4" show-word-limit :maxlength="100" resize="none"></el-input>
            </el-form-item>
            <div class="estimated-time" v-if="estimatedTime">{{ $lang('预估货物到达时间') }}：{{ estimatedTime }}{{ $lang('天') }}</div>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div class="bc-bottom">
      <el-button type="primary" @click="saveSubmit('sizeForm')" :loading="keyBtn" class="h48">{{ $lang('立即下单') }} </el-button>
    </div>
    <!-- </div> -->
    <SmartSpot v-model="smartSpot"></SmartSpot>
    <AddressBook v-model="addrBook" :selectType="selectType" @single-row-select="singleRowSelect" ref="address"></AddressBook>
    <InsuredStatement :infoVisible="infoVisible" @closeInsured="closeInsured"></InsuredStatement>
    <DimensionalInfo  :key="componentKey" :visible="dimensionalInfoVisible" @save="saveDimensionalInfo" @dimensionalInfoClose="dimensionalInfoVisible = false"></DimensionalInfo>

  </div>
</template>
<script>
import { DIC, RESPONSE_SUCCESS } from '@constants'
import { checkAddressFormat, checkGoodsName, integerWeight, isName, phoneAndMobile, RULES, VALIDATION } from '@utils/rules'
import SmartSpot from './SmartSpot'
import AddressBook from './AddressBook'
import DimensionalInfo from './components/DimensionalInfo.vue'

import {
  checkRepeatCustomerOrderId,
  customerInfo,
  getAging,
  getCoefficientByQuery,
  getComCost,
  getComputationCost,
  getDefaultAddress,
  getList,
  getReceiptFee,
  calFeeReceipt,
  getSettlement,
  printOrders,
  queryAddressAnalysisAddress,
  reqAddressList,
  vipOrderAdd,
  getInsuranceFlag,
  getProductTypeList,
  getupStairsValue,
  queryCustomerCodConfig,
  queryCodCalc
} from '@api/module/customer'
import InsuredStatement from '@components/dialog/InsuredStatement'
import dayjs from 'dayjs'
import { mapActions } from 'vuex'
import * as Api from '@api/base/public'

export default {
  name: 'SingleOrder',
  components: {
    SmartSpot,
    AddressBook,
    DimensionalInfo,
    InsuredStatement,
  },
  data() {
    return {
      componentKey: 0,
      DIC,
      COM_HTTP: {
        reqAdd: vipOrderAdd,
      },
      packageNumberVolumeDisabled: false,
      dimensionalInfoVisible: false,
      transferVisible: false,
      showClick: false,
      printOptions: {
        btnTitle: '下单并打印',
        btnType: 'primary',
        isHideIcon: true,
      },
      printOrder: false,
      keyBtn: false,
      keyBtn1: false,
      getOrderId: '', // 获取下单并打印的订单id
      rules: {
        senderName: [RULES.requiredTrim, { validator: isName }],
        senderMobilePhone: [RULES.required, { validator: phoneAndMobile }, RULES.lengthTenThirdteen],
        senderProvince: [RULES.requiredSelect],
        senderDetailedAddress: [RULES.required, { validator: checkAddressFormat }],
        receiverName: [RULES.requiredTrim, { validator: isName }],
        receiverMobilePhone: [RULES.required, { validator: phoneAndMobile }, RULES.lengthTenThirdteen],
        receiverProvince: [RULES.requiredSelect],
        receiverDetailedAddress: [RULES.required, { validator: checkAddressFormat }],
        goods: [RULES.required],
        goodsName: [RULES.requiredTrim, { validator: checkGoodsName }],
        packageTotalWeight: [RULES.required, { validator: integerWeight }],
        packageNumber: [RULES.required, { validator: integerWeight }],
        packageTotalVolume: [RULES.required],
        // packageNumber: [RULES.required],
        payment: [RULES.requiredSelect],
        insured: [RULES.requiredSelect],
        expressType: [RULES.requiredSelect],
        isElevator: [RULES.requiredSelect],
      },
      addrBook: false,
      smartSpot: false,
      infoVisible: false, // 保价费声明弹窗
      defaultFormData: {},
      showCollectionfee:false,
      maxCollectionMoney:0,//代收款上限
      businessModelType:-1,//代收款类型  32直营  33加盟
      formData: {
        isCollectionfee:0,//是否代收货款  
        collectionfee:0.00,//代收货款金额
        collectionfeeTax:0.00,//代收货款手续费
        completeDelivery: 0, // 是否齐套配送 0否 1是

        senderName: '', // 寄件人姓名,
        senderMobilePhone: '', // 寄件人手机号,
        senderProvinceId: '', // 寄件省份id,
        senderProvinceName: '', // 寄件省份名称,
        senderCityId: '', // 寄件城市id,
        senderCityName: '', // 寄件城市名称,
        senderAreaId: '', // 寄件区域id,
        senderAreaName: '', // 寄件区域名称,
        // senderTownship: '',
        // senderTownshipId: '',
        senderProvince: '', // 寄件区省/市/区
        senderDetailedAddress: '', // 寄件详细地址,
        senderPostalCode: '', // 寄件邮编,
        receiverName: '', // 收件人姓名,
        receiverMobilePhone: '', // 收件人手机号,
        receiverProvinceId: '', // 收件省份id,
        receiverProvinceName: '', // 收件省份名称,
        receiverCityId: '', // 收件城市id,
        receiverCityName: '', // 收件城市名称,
        receiverAreaId: '', // 收件区域id,
        receiverAreaName: '', // 收件区域名称,
        // receiverTownship: '',
        // receiverTownshipId: '',
        receiverProvince: '', // 收件区省/市/区
        receiverDetailedAddress: '', // 收件详细地址,
        receiverPostalCode: '', // 收件邮编,
        transferName: '', // 退转件姓名,
        transferMobilePhone: '', // 退转件手机号,
        transferProvinceId: '', // 退转件省份id,
        transferProvinceName: '', // 退转件省份名称,
        transferCityId: '', // 退转件城市id,
        transferCityName: '', // 退转件城市名称,
        transferAreaId: '', // 退转件区域id,
        transferAreaName: '', // 退转件区域名称,
        transferProvince: '', // 退转件区省/市/区
        transferDetailedAddress: '', // 退转件详细地址,
        transferCompany: '', // 退转件公司名称
        transferPostalCode: '', // 退转件邮编
        insured: 0, // 是否保价1是，0否,
        declaredValue: '', // 保价金额,
        insuredValue: 0, // 保价费,
        goods: '', // 物品类型
        goodsTypeId: '', // 物品类型id,
        goodsTypeCode: '', // 物品类型编码,
        goodsTypeName: '', // 物品类型名称,
        goodsName: '', // 物品名称,
        packageTotalWeight: 1, // 物品重量,
        payment: { code: 'PP_PM', name: this.$lang('Bulanan'), id: 7, type: 'ZD106' }, // 支付方式
        paymentModeId: '7', // 支付方式id,
        paymentModeCode: 'PP_PM', // 支付方式编码,
        paymentModeName: this.$lang('PP_PM'), // 支付方式名称,
        expressType: '', // 快递类型
        expressTypeCode: '', // 快递类型code
        expressTypeName: '', // 快递类型name
        codMoney: '', // COD,
        codFee: 0, // COD手续费,
        standardValue: 0, // 参考运费,
        packageNumber: 1, // 件数,
        boxStandard: '', // 箱材规格
        boxStandardId: '', // 箱材规格id,
        boxStandardCode: '', // 箱材规格编码,
        boxStandardName: '', // 箱材规格名称,
        boxPrice: 0, // 箱材单价,
        boxTotalPrice: 0, // 箱材总价,
        remarks: '', // 备注,
        settlementWeight: 0, // 结算重量
        // packageChargeWeight: 1, // 结算重量
        customerOrderId: '',
        senderCompany: '',
        receiverCompany: '',
        checkSenderFlag: '', // 寄件人保存至地址簿
        checkReceiverFlag: '', // 寄件人保存至地址簿
        checkTransferFlag: '', // 退转件人保存至地址簿
        signReceipt: 0, // 签回单 0否 1是
        receiptFreight: 0, // 回单金额
        receiptBusinessName: '',
        receiptBusinessType: '',
        packageTotalVolume: 0.0, // 总体积
        packageChargeWeight: 1.0, // 计费重量
        packateVolume: 0.0, // 体积重
        ifTransfer: 0, // 是否退转件
        oldSenderCityId: '',
        oldRecieverCityId: '',
        productTypeWeightMin: 0,
        productTypeWeightMax: 99999,
        isUpstairs: 0, // 是否上楼
        upStairsValue: 0, // 上楼费
        isElevator: '', // 是否电梯,是1 否2
      },
      receiptFreight: 0,
      receiptBusinessName: '',
      receiptBusinessType: '',
      isReceiptFlag: 0,
      checkSenderFlag: false,
      checkReceiverFlag: false,
      checkTransferFlag: false,
      initData: {
        url: '/oauth/sysRoleResource/getAppResources',
        type: 'app',
        leftText: this.$lang('未选权限'),
        rightText: this.$lang('已选权限'),
        rightOptText: this.$lang('全部权限'),
        exculdeIdsParam: 'resourceIds',
      },
      settlementId:0,
      selectType: 1,
      sendAddressData: {
        formProps: {
          provinceIdProp: 'senderProvinceId',
          provinceNameProp: 'senderProvinceName',
          cityIdProp: 'senderCityId',
          cityNameProp: 'senderCityName',
          areaIdProp: 'senderAreaId',
          areaNameProp: 'senderAreaName',
          // townIdProp: 'senderTownshipId',
          // townNameProp: 'senderTownshipName',
          zipcodeProp: 'senderPostalCode',
        },
        defaultData: {},
      },
      receiverAddressData: {
        formProps: {
          provinceIdProp: 'receiverProvinceId',
          provinceNameProp: 'receiverProvinceName',
          cityIdProp: 'receiverCityId',
          cityNameProp: 'receiverCityName',
          areaIdProp: 'receiverAreaId',
          areaNameProp: 'receiverAreaName',
          // townIdProp: 'receiverTownshipId',
          // townNameProp: 'receiverTownshipName',
          zipcodeProp: 'receiverPostalCode',
        },
        defaultData: {},
      },
      transferData: {
        formProps: {
          provinceIdProp: 'transferProvinceId',
          provinceNameProp: 'transferProvinceName',
          cityIdProp: 'transferCityId',
          cityNameProp: 'transferCityName',
          areaIdProp: 'transferAreaId',
          areaNameProp: 'transferAreaName',
          // townIdProp: 'transferTownshipId',
          // townNameProp: 'transferTownshipName',
          zipcodeProp: 'transferPostalCode',
        },
        defaultData: {},
      },
      insuredDic: [
        { code: 0, label: this.$lang('否'), name: this.$lang('否') },
        { code: 1, label: this.$lang('是'), name: this.$lang('是') },
      ],
      signReceiptDic: [
        { code: 0, label: this.$lang('否'), name: this.$lang('否') },
        { code: 1, label: this.$lang('是'), name: this.$lang('是') },
      ],
      elevatorDic: [
        { code: 0, label: this.$lang('否'), name: this.$lang('否') },
        { code: 1, label: this.$lang('是'), name: this.$lang('是') },
      ],
      collectionfeeDic: [
        { code: 0, label: this.$lang('否'), name: this.$lang('否') },
        { code: 1, label: this.$lang('是'), name: this.$lang('是') },
      ],
      completeDeliveryDic: [
        { code: 0, label: this.$lang('否'), name: this.$lang('否') },
        { code: 1, label: this.$lang('是'), name: this.$lang('是') },
      ],
      // payTypesDic: [{ code: 'PP_PM', name: this.$lang('寄付月结'), id: 319, type: 'ZD106' }, { code: 'PP_CASH', name: this.$lang('寄付现结'), id: 320, type: 'ZD106' }, { code: 'CC_CASH', name: this.$lang('到付现结'), id: 321, type: 'ZD106' }],
      countParams: '',
      appProductTypeVOList: [], // 轻抛系数列表
      estimatedTime: '', // 预估时间
      expressTypeList: [], // 快递类型
      prevStandardCost: -1, // 记录上一次标准金额值
      transferDic: [
        { code: 0, label: this.$lang('否'), name: this.$lang('否') },
        { code: 1, label: this.$lang('是'), name: this.$lang('是') },
      ],
      insuranceFlag: 0,
    }
  },

  created() {
    this.fromType = this.comeFrom
    if (this.id) {
      this.getDetail()
    }
    if (this.formData.insured === 1) {
      // 是否保价1是，0否,
      this.rules.declaredValue = [RULES.required, RULES.declaredValue]
    }
    // this.getReceiptFee() // 获取回单金额
    this.getCustomerInfo()
    this.getInsuranceFlag()
  },
  computed: {
    // 用户信息
    userInfo() {
      return this.$store.state.base.user || {}
    },
    // taxes() {
    //   return ((this.formData.insuredValue + this.formData.receiptFreight + this.formData.upStairsValue) * 0.06).toFixed(2)
    // },
    // 总运费显示
    totalFreight() {
      debugger
      const standardValue = Number.parseFloat(this.formData.standardValue).toFixed(2)
      const insuredValue = Number.parseFloat(this.formData.insuredValue).toFixed(2)
      const receiptFreight = !this.formData.receiptFreight ? Number.parseFloat(0).toFixed(2) : Number.parseFloat(this.formData.receiptFreight).toFixed(2)
      const upStairsValue = Number.parseFloat(this.formData.upStairsValue).toFixed(2)
      const collectionfee = Number.parseFloat(this.formData.collectionfeeTax).toFixed(2)

      console.log(standardValue)
      console.log(insuredValue)
      console.log(receiptFreight)
      console.log(upStairsValue)
      // 总运费 = 参考运费 + 保价费 + 回单费 + 上楼费 + 税费
      return (parseFloat(standardValue) + parseFloat(insuredValue) + parseFloat(receiptFreight) + parseFloat(upStairsValue)+ parseFloat(collectionfee)).toFixed(2)
    },
  },
  watch: {
    // 物品类型
    async 'formData.goods'(val) {
      const { id: goodsTypeId, code: goodsTypeCode, name: goodsTypeName } = val
      Object.assign(this.formData, { goodsTypeId, goodsTypeCode, goodsTypeName })
      const { declaredValue, goods, insured } = this.formData
      if (insured === 1 && goods && parseFloat(declaredValue) > 0) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
        this.prevStandardCost = -1
      }
      if (goodsTypeCode === 'bm000001') {
        Object.assign(this.formData, { insured: 0, declaredValue: '' })
        this.formData.insuredValue = 0
        this.prevStandardCost = -1
      }
    },
    async 'formData.receiverAreaId'(val){
      if(val){
        this.verifyCollectionfee()
      }else{
        this.showCollectionfee=false
        this.formData.isCollectionfee=0
        this.formData.collectionfee=0.00
        this.formData.collectionfeeTax=0.00

      }
    },
  
    async 'formData.receiverDetailedAddress'(val){
      if(val){
        this.verifyCollectionfee()
      }else{
        this.showCollectionfee=false
        this.formData.isCollectionfee=0
        this.formData.collectionfee=0.00
        this.formData.collectionfeeTax=0.00
      }
    },
    // 支付方式
    async 'formData.payment'(val) {
      const { id: paymentModeId, code: paymentModeCode, name: paymentModeName } = val
      Object.assign(this.formData, { paymentModeId, paymentModeCode, paymentModeName })
      const { senderProvince, receiverProvince, packageTotalWeight } = this.formData
      if (senderProvince && receiverProvince && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
      // 到付现结不支持保价
      if (val.code === 'CC_CASH') {
        Object.assign(this.formData, { insured: 0, declaredValue: '', signReceipt: 0 })
        this.formData.insuredValue = 0
        this.formData.receiptFreight = 0
        this.prevStandardCost = -1
      }
      console.log(this.formData)
    },
    async 'formData.expressType'(val) {
      // const {code, name} = val
      // Object.assign(this.formData, {expressTypeCode: code, expressTypeName: name})
      // 重新计算轻抛系数
      this.countWeightTotal()
    },
    // 运费计算
    async 'formData.senderProvince'(val) {
      const { receiverProvince, packageTotalWeight } = this.formData
      if (receiverProvince && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
      this.getAging()
    },
    // 运费计算
    async 'formData.receiverProvince'(val) {
      const { senderProvince, packageTotalWeight } = this.formData
      if (senderProvince && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
      this.getAging()
    },
    async 'formData.transferProvince'(val) {
      const { transferProvince, packageTotalWeight } = this.formData
      if (transferProvince && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
      this.getAging()
    },
    // 运费重量
    async 'formData.packageTotalWeight'(val) {
      const { packateVolume } = this.formData
      this.formData.packageChargeWeight = packateVolume > val ? packateVolume : val
      if (
        this.formData.productTypeWeightMin !== null &&
        this.formData.productTypeWeightMax !== null &&
        (this.formData.packageChargeWeight < this.formData.productTypeWeightMin || this.formData.packageChargeWeight > this.formData.productTypeWeightMax)
      ) {
        this.$message.error(this.$lang('当前快递类型的计费重量需在') + this.formData.productTypeWeightMin + '-' + this.formData.productTypeWeightMax + 'kg')
        return
      }
    },
    // 计费重量
    async 'formData.packageChargeWeight'(val) {
      const { senderProvince, receiverProvince } = this.formData
      if (senderProvince && receiverProvince && val > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
    },
    // 箱材规格计算
    async 'formData.boxStandard'(val) {
      const { id: boxStandardId, name: boxStandardName, salesPrice: boxPrice } = val
      const res = await this.calcBoxStandard({ boxStandardId, boxStandardName, boxPrice })
      Object.assign(this.formData, res, {
        // 箱材规格id
        boxStandardId,
        // 箱材规格名称
        boxStandardName,
        // 箱材单价
        boxPrice,
      })
    },
    // 监听总件数变化，当小于等于1时重置是否齐套配送为否
    'formData.packageNumber'(val) {
      if (val <= 1) {
        this.formData.completeDelivery = 0
      }
    },
    // 箱材数量
    async 'formData.boxNumber'(val) {
      const { boxStandardId, boxStandardName, boxPrice } = this.formData
      const res = await this.calcBoxStandard({ boxStandardId, boxStandardName, boxPrice })
      Object.assign(this.formData, res)
    },
    // 保价费计算
    async 'formData.declaredValue'(val) {
      const { goods, insured } = this.formData
      if (insured === 1 && goods && parseFloat(val) > 0) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
        this.prevStandardCost = -1
      }
    },
  },
  mounted() {
    // 寄件人默认信息
    this.getDefaultAddress({ type: 1 })
    // 收件人默认信息
    this.getDefaultAddress({ type: 2 })
    // 轻抛系数列表
    this.getLightTossCoefficient()
  },
  methods: {
    ...mapActions(['UPDATE_PRINT_STOCK']),
    async blurCollectionfee(val){
      debugger
      if(!this.formData.collectionfee||this.formData.collectionfee==0){
        this.$message.error(this.$lang("代收款金额不能为0"))
      }else if(this.businessModelId==33&&(parseFloat(this.formData.collectionfee)>parseFloat(this.maxCollectionMoney))){
        
        
          this.$message.error(this.$lang("该目的网点代收上限")+this.maxCollectionMoney)
          this.formData.collectionfee=0.00
          this.formData.collectionfeeTax=0.00
        
        
      }else{
        const now = new Date()
       const res =await queryCodCalc({
        collectionfee:this.formData.collectionfee,
        dateTime:dayjs(now).format('YYYY-MM-DD HH:mm:ss'),
        customerCode:this.userInfo.customerCode
      })
      if(res&&res.data){
        if(res.data.customerFee){
          this.formData.collectionfeeTax=res.data.customerFee
        }
      }
      }
      
     
    },
    saveDimensionalInfo(dimensionsData) {
      this.dimensionalInfoVisible = false
      debugger
      if (!dimensionsData) {
        this.packageNumberVolumeDisabled = false
        return false
      }
      if (dimensionsData.totalVolume > 0 && dimensionsData.totalPackageNumber > 0) {
        debugger
        this.formData.packageNumber = dimensionsData.totalPackageNumber
        this.formData.packageTotalVolume = dimensionsData.totalVolume
        this.formData.dimensions = dimensionsData.dimensions
        this.packageNumberVolumeDisabled = true
      } else {
        debugger
        this.formData.packageNumber =1
        this.formData.packageTotalVolume =0.0
        this.packageNumberVolumeDisabled = false
      }
    },
    async verifyCollectionfee(){
      console.log(this.formData.receiverDetailedAddress)
      if(this.formData.receiverAreaId&&this.formData.receiverDetailedAddress){
        const res = await queryCustomerCodConfig({
          provinceId:this.formData.receiverProvinceId,
          cityId:this.formData.receiverCityId,
          areaId:this.formData.receiverAreaId,
          province:this.formData.receiverProvinceName,
          city:this.formData.receiverCityName,
          area:this.formData.receiverAreaName,
          details:this.formData.receiverDetailedAddress,
        })
        if(res&&res.code==1&&res.data){
          if(res.data.maxCollectionMoney){
            this.maxCollectionMoney=res.data.maxCollectionMoney
          }
          if(res.data.isOpenCod==1){
            this.showCollectionfee=true
          }else if(res.data.isOpenCod==2){
            this.showCollectionfee=false
            this.formData.collectionfee=0.00
            this.formData.collectionfeeTax=0.00
            this.formData.isCollectionfee = 0
          }
          if(res.data.businessModelId){
            this.businessModelId=res.data.businessModelId
          }
        }
      }

    
      
    },
    async getupStairsValue() {
      // 获取上楼费
      const { packateVolume } = this.formData
      this.formData.packageChargeWeight = packateVolume > this.formData.packageTotalWeight ? packateVolume : this.formData.packageTotalWeight
      debugger
      if (this.formData.isElevator === '' || this.formData.isUpstairs === 0) {
        this.formData.upStairsValue = 0
        this.formData.isElevator = 0
        return
      }
      this.$refs['sizeForm'].validate(async (valid) => {
        if (valid) {
          this.keyBtn = true
          const params = {
            costNum: this.formData.packageNumber, // 件数
            costWeight: this.formData.packageChargeWeight, // 计费重量
            goodsCode: this.formData.goods.code, // 物品类型code
            isElevator: this.formData.isElevator, // 是否电梯,是1 否2
            productTypeCode: this.formData.expressType, // 产品类型code
          }
          const { code, data, msg } = await getupStairsValue(params)
          if (code === RESPONSE_SUCCESS) {
            this.formData.upStairsValue = data || 0
          } else {
            this.$message.error(msg)
          }
          this.keyBtn = false
        } else {
          setTimeout(() => {
            this.formData.isElevator = ''
          }, 0)
        }
      })
    },
    // 获取轻抛系数
    async getLightTossCoefficient() {
      const { code, data, msg } = await getList()
      if (code === RESPONSE_SUCCESS) {
        if (data.appProductTypeVOList) {
          this.appProductTypeVOList = data.appProductTypeVOList
        }
      } else {
        this.$message.warning(msg)
      }
    },
    async getCoefficientByQuery(expressTypeCode) {
      if (!expressTypeCode) {
        return null
      }
      const { code, data, msg } = await getCoefficientByQuery({ code: expressTypeCode })
      if (code === RESPONSE_SUCCESS) {
        return data
      } else {
        this.$message.error(msg)
        return null
      }
    },
    async addOrderCheckRepeatCustomerOrderId(customerOrderId) {
      const param = {
        customerOrderId: customerOrderId,
      }
      const { code, data, msg } = await checkRepeatCustomerOrderId(param)
      if (code === RESPONSE_SUCCESS) {
        return data
      } else {
        this.$message.warning(msg)
      }
    },
    // 件数改变重新计算体积
    packageNumberChange() {
      if (this.countParams) {
        this.countWeight()
      }
      this.getupStairsValue()
    },
    // 计算体积
    countWeight() {
      if (!this.countParams) {
        // 没有输入
        this.$message.warning(this.$lang('输入有误，已被忽略求总体积!'))
        return
      }
      const countList = this.countParams.split('*')
      if (countList.length !== 3) {
        // 输入的乘号不足
        this.$message.warning(this.$lang('输入有误，已被忽略求总体积!'))
        return
      }
      if (!this.formData.packageNumber) {
        // 件数不存在
        this.$message.warning(this.$lang('输入有误，已被忽略求总体积!'))
      }
      let res = 1
      let flag = true
      for (let i = 0; i < countList.length; i++) {
        if (isNaN(+countList[i]) || countList[i].match(/^\s*$/)) {
          // 如果存在非数字输入
          this.$message.warning(this.$lang('输入有误，已被忽略求总体积!'))
          flag = false
          break
        } else if (countList[i].length > 5) {
          this.$message.warning(this.$lang('最大值不超过五位数'))
          break
        } else if (countList[i].indexOf('.') > -1) {
          this.$message.warning(this.$lang('不支持小数点'))
          break
        } else {
          res *= Number(countList[i])
        }
      }
      if (flag) {
        // 计算完成
        res = res * this.formData.packageNumber
        if (res.toFixed(3) > 99999000) {
          this.$message.warning(this.$lang('总体积超额，请重新填写'))
          return
        }
        this.formData.packageTotalVolume = (res / 1000000).toFixed(3)
        this.countWeightTotal()
      }
    },
    // 轻抛系数计算体积重
    async countWeightTotal() {
      const { expressTypeCode, packageTotalVolume, packageTotalWeight } = this.formData
      const data = await this.getCoefficientByQuery(expressTypeCode)
      if (data && (packageTotalVolume || packageTotalVolume === 0)) {
        // 体积重=根据总体积/轻抛系数
        const packateVolume = ((packageTotalVolume * 1000000) / data.lightThrowingCoefficient).toFixed(2)
        if (packateVolume > 99999.9) {
          this.$message.warning(this.$lang('体积重限额，请重新调整总体积'))
          return
        }
        this.formData.packateVolume = Number(packateVolume)
        this.formData.packageChargeWeight = packateVolume > packageTotalWeight ? packateVolume : packageTotalWeight
      }
      // 计算上楼费
      this.getupStairsValue()

      // 计算运费
      this.calcStandardCost(this.formData)
    },
    beforePrint() {
      const userInfo = this.userInfo
      if (userInfo.surfaceFormat === 1) {
        this.$alert(this.$lang('请先到我的资料里设置面单格式'), this.$lang('提示'), {
          confirmButtonText: this.$lang('确定'),
        })
        return
      } else {
        this.printOrder = true
        this.saveSubmit('sizeForm')
      }
    },
    // 获取打印数据
    async getPrintData(type) {
      const ids = [this.getOrderId]
      const params = { ids: ids, printType: type, isVip: true }
      const { code, msg, data } = await printOrders(params)
      if (code === 1) {
        if (data.length) this.$message.success(this.$lang('已生成打印数据，正在打印中...'))
        this.printOrder = false
        setTimeout(() => {
          // 更新库存面单
          if (this.exportStatus !== 'already_print') {
            this.UPDATE_PRINT_STOCK(true)
          }
        }, 1100)
        return data || []
      } else {
        this.$message.error(this.$lang(msg))
        return []
      }
    },
    // // 获取打印数据
    // async getPrintData(type) {
    //   return [this.formData]
    // },
    discern(type) {
      let text
      switch (type) {
        case 0:
          if (!this.formData.analysisAddress) {
            return
          }
          text = this.formData.analysisAddress
          text = text.replace(/\s/g, '')
          queryAddressAnalysisAddress({ text }).then((res) => {
            const { code, msg, data } = res
            if (code === RESPONSE_SUCCESS) {
              if (data) {
                const { province, city, county, provinceCode, cityCode, countyCode, detail, phonenum, person } = res.data || {}
                const obj = {
                  senderName: person,
                  senderMobilePhone: phonenum,
                  senderDetailedAddress: detail,
                  senderProvince: {
                    senderProvinceName: province,
                    senderProvinceId: provinceCode,
                    senderCityId: cityCode,
                    senderCityName: city,
                    senderAreaId: countyCode,
                    senderAreaName: county,
                  },
                }
                Object.assign(this.formData, obj)
              }
            } else {
              this.$message.error(msg)
            }
          })
          break
        case 1:
          this.formData.analysisAddress = ''
          break
        case 2:
          if (!this.formData.analysisAddress1) {
            return
          }
          text = this.formData.analysisAddress1
          text = text.replace(/\s/g, '')
          queryAddressAnalysisAddress({ text }).then((res) => {
            const { code, msg, data } = res
            if (code === RESPONSE_SUCCESS) {
              if (data) {
                const { province, city, county, provinceCode, cityCode, countyCode, detail, phonenum, person } = res.data || {}
                const obj = {
                  receiverName: person,
                  receiverMobilePhone: phonenum,
                  receiverDetailedAddress: detail,
                  receiverProvince: {
                    receiverProvinceName: province,
                    receiverProvinceId: provinceCode,
                    receiverCityId: cityCode,
                    receiverCityName: city,
                    receiverAreaId: countyCode,
                    receiverAreaName: county,
                  },
                }
                Object.assign(this.formData, obj)
              }
            } else {
              this.$message.error(msg)
            }
          })
          break
        case 3:
          this.formData.analysisAddress1 = ''
          break
        default:
          break
      }
    },
    openInsured() {
      this.infoVisible = true
    },
    closeInsured() {
      this.infoVisible = false
    },
    // 运费计算
    async calcStandardCost(data) {
      const { senderProvince, receiverProvince, packageChargeWeight, paymentModeId, transferProvince } = this.formData
      console.log(senderProvince)
      const result = {
        // 寄件省份id
        senderProvinceId: senderProvince.senderProvinceId,
        // 寄件省份名称
        senderProvinceName: senderProvince.senderProvinceName,
        // 寄件城市id
        senderCityId: senderProvince.senderCityId,
        // 寄件城市名称
        senderCityName: senderProvince.senderCityName,
        // 寄件区域id
        senderAreaId: senderProvince.senderAreaId,
        // 寄件区域名称
        senderAreaName: senderProvince.senderAreaName,
        // 寄件乡镇id
        // senderTownshipId: senderProvince.senderTownshipId,
        // // 寄件乡镇名称
        // senderTownship: senderProvince.senderTownshipName,
        // 收件省份id
        receiverProvinceId: receiverProvince.receiverProvinceId,
        // 收件省份名称
        receiverProvinceName: receiverProvince.receiverProvinceName,
        // 收件城市id
        receiverCityId: receiverProvince.receiverCityId,
        // 收件城市名称
        receiverCityName: receiverProvince.receiverCityName,
        // 收件区域id
        receiverAreaId: receiverProvince.receiverAreaId,
        // 收件区域名称
        receiverAreaName: receiverProvince.receiverAreaName,
        // 收件区域id
        // receiverTownshipId: receiverProvince.receiverTownshipId,
        // // 收件区域名称
        // receiverTownship: receiverProvince.receiverTownshipName,
        // 收件省份id
        transferProvinceId: transferProvince.transferProvinceId,
        // 收件省份名称
        transferProvinceName: transferProvince.transferProvinceName,
        // 收件城市id
        transferCityId: transferProvince.transferCityId,
        // 收件城市名称
        transferCityName: transferProvince.transferCityName,
        // 收件区域id
        transferAreaId: transferProvince.transferAreaId,
        // 收件区域名称
        transferAreaName: transferProvince.transferAreaName,
        // // 收件乡镇id
        // transferTownshipId: transferProvince.transferTownshipId,
        // // 收件乡镇名称
        // transferTownshipName: transferProvince.transferTownshipName,
      }
      const promises = [
        // 获取起始地址ID
        this.getSettlement(result.senderProvinceId, result.senderCityId, result.senderAreaId),
        // 获取目的地地址ID
        this.getSettlement(result.receiverProvinceId, result.receiverCityId, result.receiverAreaId),
      ]
      const [startAddressId, endAddressId] = await Promise.all(promises)
      // 运费
      const obj = {}
      // 如果起始地址且目的地地址ID存在
      if (startAddressId && endAddressId) {
        // 获取运费

        const res = await this.getComCost(packageChargeWeight, startAddressId, endAddressId, paymentModeId)
        //模拟数据
        //const res = await this.getComCost(1.0,225354,232906,101)
        obj.standardValue = res.cost
        obj.settlementWeight = res.setWeight
        obj.standardCost = res.standardCost // 标准金额字段 用来计算保价费的
        this.calcInsuredCost() // 执行保价费计算
      } else {
        // 保价时，若起始地址id存在null，设置参考运费、标准金额以及保价费为0,初始化上一次标准金额值
        if (this.formData.insured === 1) {
          this.formData.standardValue = 0
          this.formData.standardCost = 0
          this.formData.insuredValue = 0
          this.prevStandardCost = -1
        }
      }
      // 返回结果
      return {
        ...result,
        ...obj,
      }
    },
    // 获取默认地址
    async getDefaultAddress(param) {
      const { code, msg, data } = await getDefaultAddress(param)
      if (code === RESPONSE_SUCCESS) {
        if (data) {
          this.singleRowSelect(data, param.type)
        }
        // this.defaultFormData = commonFun.deepClone(this.formData)
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    // 箱材规格计算
    async calcBoxStandard({ boxStandardId, boxStandardName, boxPrice } = {}) {
      const { boxNumber } = this.formData
      // 箱数量
      const boxTotalPrice = this.$common.floatNumSub(boxNumber ? boxNumber * boxPrice : 0)
      return {
        // 箱材总价格
        boxTotalPrice,
      }
    },
    // 打开地址
    open(selectType) {
      this.addrBook = true
      this.selectType = selectType
      const data = selectType === 1 ? this.curentSend : this.curentReceiver
      this.$refs.address.updateBtnStauts(data)
      this.$refs.address.initData()
    },
    singleRowSelect(data, type) {
      if (!data.areaId) {
        return
      }
      const { name, mobile, detailedAddress, companyName, zipcode } = data
      if (type === 1) {
        // 1寄件2取件
        this.formData.senderName = name // 寄件人姓名,
        this.formData.senderMobilePhone = mobile // 寄件人手机号
        this.formData.senderDetailedAddress = detailedAddress // 寄件详细地址
        this.formData.senderCompany = companyName
        this.formData.senderPostalCode = zipcode
        this.curentSend = data
        this.handleProvice(data, type)
      } else if (type === 2) {
        this.formData.receiverName = name // 收件人姓名,
        this.formData.receiverMobilePhone = mobile // 收件人手机号
        this.formData.receiverDetailedAddress = detailedAddress // 收件详细地址
        this.formData.receiverCompany = companyName
        this.formData.receiverPostalCode = zipcode
        this.curentReceiver = data
        this.handleProvice(data, type)
      } else if (type === 3) {
        this.formData.transferName = name // 收件人姓名,
        this.formData.transferMobilePhone = mobile // 收件人手机号
        this.formData.transferDetailedAddress = detailedAddress // 收件详细地址
        this.formData.transferCompany = companyName
        this.formData.transferPostalCode = zipcode
        this.handleProvice(data, type)
      }
    },
    /**
     * 是否保价
     */
    changeInsured(val) {
      this.formData.insured = val
      if (val === 0) {
        this.formData.declaredValue = ''
        this.formData.insuredValue = 0
      }
    },
    // 是否代收货款
    changeCollectionfee(val) {
      if(val==0){
        this.formData.isCollectionfee=0
        this.formData.collectionfee=0.00
        this.formData.collectionfeeTax=0.00
      }
     
    },
    changeTransfer(val) {
      if (val === 1) {
        this.transferVisible = true
      } else {
        this.transferVisible = false
        this.formData.transferName = ''
        this.formData.transferMobilePhone = ''
        this.formData.transferProvinceId = ''
        this.formData.transferProvinceName = ''
        this.formData.transferCityId = ''
        this.formData.transferCityName = ''
        this.formData.transferAreaId = ''
        this.formData.transferAreaName = ''
        this.formData.transferProvince = ''
        this.formData.transferDetailedAddress = ''
        this.formData.transferCompany = ''
      }
    },
    validateTransfer() {
      if (this.formData.ifTransfer === 1) {
        if (this.formData.transferName === '') {
          this.$message.warning(this.$lang('退转件人姓名不能为空'))
          return false
        }
        if (this.formData.transferName.length > 50) {
          this.$message.warning(this.$lang('退转件人姓名长度不能大于50个字符'))
          return false
        }
        if (this.formData.transferMobilePhone === '') {
          this.$message.warning(this.$lang('退转件人联系电话不能为空'))
          return false
        }
        if (!VALIDATION.phoneAndMobile.value.test(this.formData.transferMobilePhone)) {
          this.$message.warning(this.$lang('退转件人联系电话格式不正确'))
          return false
        }
        if (this.formData.transferProvince === '') {
          this.$message.warning(this.$lang('退转件人省市区不能为空'))
          return false
        }
        if (this.formData.transferDetailedAddress === '') {
          this.$message.warning(this.$lang('退转件人详细地址不能为空'))
          return false
        }
      }
    },
    /**
     * 是否签回单
     */
    changeSignReceipt(val) {
      if (val === 0) {
        this.formData.receiptFreight = 0
        this.formData.receiptBusinessName = ''
        this.formData.receiptBusinessType = ''
        this.formData.signReceipt = 0
      } else if (val === 1) {
        this.formData.receiptFreight = this.receiptFreight
        this.formData.receiptBusinessName = this.receiptBusinessName
        this.formData.receiptBusinessType = this.receiptBusinessType
        this.formData.signReceipt = 1
      }
    },
    // 收件人姓名或者电话改变
    changeReceiverName(item) {
      this.formData.receiverName = item.name
      this.formData.receiverMobilePhone = item.mobile
      this.formData.receiverCompany = item.companyName
      this.formData.receiverDetailedAddress = item.detailedAddress
      this.formData.receiverPostalCode = item.zipcode
      this.handleProvice(item, 2)
    },
    // 寄件人姓名或者电话改变
    changeSenderName(item) {
      this.formData.senderName = item.name
      this.formData.senderMobilePhone = item.mobile
      this.formData.senderCompany = item.companyName
      this.formData.senderDetailedAddress = item.detailedAddress
      this.formData.senderPostalCode = item.zipcode
      this.handleProvice(item, 1)
    },
    changeTransferName(item) {
      this.formData.transferName = item.name
      this.formData.transferMobilePhone = item.mobile
      this.formData.transferCompany = item.companyName
      this.formData.transferDetailedAddress = item.detailedAddress
      this.formData.transferPostalCode = item.zipcode
      this.handleProvice(item, 3)
    },
    // 表单保存 下单并保存
    // savePrintSubmit(formName) {
    //   console.log('formName',)
    // },
    // 表单保存  立即下单
    async saveSubmit(formName) {
      var validateTransferResult = this.validateTransfer()
      if (validateTransferResult === false) {
        return
      }
      if (this.formData.isCollectionfee == 1 &&!this.formData.collectionfee) {
        this.$message.error(this.$lang('代收货款金额必须大于0'))
        return
      }
      if (this.userInfo.freightStatus == 1 && (!this.formData.standardValue || parseFloat(this.formData.standardValue) <= 0)) {
        this.$message.error(this.$lang('参考运费必须大于0'))
        return
      }
      if (this.formData.paymentModeId === 321 && this.formData.insured !== 0) {
        this.$message.error(this.$lang('到付件不支持保价'))
        return
      }
      if (this.formData.insured === 1 && (!this.formData.declaredValue || parseFloat(this.formData.declaredValue) <= 0)) {
        this.$message.error(this.$lang('保价金额必须大于0'))
        return
      }
      if (this.formData.customerOrderId) {
        if ((await this.addOrderCheckRepeatCustomerOrderId(this.formData.customerOrderId)) === false) {
          this.$message.error(this.$lang('客户订单号重复'))
          return
        }
      }
      if (this.formData.packageChargeWeight < this.formData.productTypeWeightMin || this.formData.packageChargeWeight > this.formData.productTypeWeightMax) {
        this.$message.error(this.$lang('当前计费重量不支持选择此快递类型，请调整货物重量或者体积'))
        return
      }
      if (this.formData.isUpstairs === 1 && !this.formData.upStairsValue && this.formData.upStairsValue !== 0) {
        this.$message.error(this.$lang('暂不支持上楼服务'))
        return
      }
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.printOrder) {
            this.keyBtn1 = true
          } else {
            this.keyBtn = true
          }
          if (this.formData.insured === 0) this.formData.declaredValue = ''
          // this.formData.packageChargeWeight = this.formData.packageTotalWeight
          this.formData.boxStandardCode = this.formData.boxStandard ? this.formData.boxStandard.code : ''
          // this.formData.boxNumber = this.formData.boxStandard ? this.formData.boxNumber : null
          this.formData.checkReceiverFlag = this.checkReceiverFlag ? 1 : 0
          this.formData.checkSenderFlag = this.checkSenderFlag ? 1 : 0
          this.formData.checkTransferFlag = this.checkTransferFlag ? 1 : 0
          this.formData.totalPackageVolume = this.formData.packageTotalVolume
          this.formData.codNeed=this.formData.isCollectionfee
          this.formData.codMoney=this.formData.collectionfee
          this.formData.codFee=this.formData.collectionfeeTax
          // this.formData.taxes = this.taxes //税费
          console.log(this.formData)
          this.vipOrderAdd(this.formData)
        } else {
          return false
        }
      })
      this.componentKey += 1;
    },
    async vipOrderAdd(reqData) {
      // 新增订单
      try {
        //模拟数据
        //         let req={
        //     "senderName":"对对对",
        //     "senderMobilePhone":"1380197814",
        //     "senderProvinceId":1000016,
        //     "senderProvinceName":"Bali",
        //     "senderCityId":1001266,
        //     "senderCityName":"Kab Bangli",
        //     "senderAreaId":1102095,
        //     "senderAreaName":"Kintamani",
        //     "senderTownship":"Abangsongan",
        //     "senderTownshipId":65484442,
        //     "senderProvince":{
        //         "senderProvinceId":1000016,
        //         "senderProvinceName":"Bali",
        //         "senderCityId":1001266,
        //         "senderCityName":"Kab Bangli",
        //         "senderAreaId":1102095,
        //         "senderAreaName":"Kintamani",
        //         "senderTownshipId":65484442,
        //         "senderTownshipName":"Abangsongan"
        //     },
        //     "senderDetailedAddress":"对对对1111",
        //     "senderPostalCode":"42426",
        //     "receiverName":"对对对",
        //     "receiverMobilePhone":"1380197814",
        //     "receiverProvinceId":1000016,
        //     "receiverProvinceName":"Bali",
        //     "receiverCityId":1001266,
        //     "receiverCityName":"Kab Bangli",
        //     "receiverAreaId":1102095,
        //     "receiverAreaName":"Kintamani",
        //     "receiverTownship":"Abangsongan",
        //     "receiverTownshipId":65484442,
        //     "receiverProvince":{
        //         "receiverProvinceId":1000016,
        //         "receiverProvinceName":"Bali",
        //         "receiverCityId":1001266,
        //         "receiverCityName":"Kab Bangli",
        //         "receiverAreaId":1102095,
        //         "receiverAreaName":"Kintamani",
        //         "receiverTownshipId":65484442,
        //         "receiverTownshipName":"Abangsongan"
        //     },
        //     "receiverDetailedAddress":"对对对222",
        //     "receiverPostalCode":"42426",
        //     "transferName":"",
        //     "transferMobilePhone":"",
        //     "transferProvince":"",
        //     "transferDetailedAddress":"",
        //     "transferCompany":"",
        //     "transferPostalCode":"",
        //     "insured":1,
        //     "declaredValue":60,
        //     "insuredValue":0,
        //     "goods":{
        //         "id":111,
        //         "name":"文件袋",
        //         "code":"0001"
        //     },
        //     "goodsTypeId":111,
        //     "goodsTypeCode":"0001",
        //     "goodsTypeName":"文件袋",
        //     "goodsName":"111",
        //     "packageTotalWeight":1,
        //     "payment":{
        //         "code":"PP_PM",
        //         "name":"Bulanan",
        //         "id":7,
        //         "type":"ZD106"
        //     },
        //     "paymentModeId":"7",
        //     "paymentModeCode":"PP_PM",
        //     "paymentModeName":"PP_PM",
        //     "expressType":"FT",
        //     "expressTypeCode":"FT",
        //     "expressTypeName":"FastTrack",
        //     "codMoney":"",
        //     "codFee":0,
        //     "standardValue":13,
        //     "packageNumber":1,
        //     "boxStandard":"",
        //     "boxStandardId":"",
        //     "boxStandardCode":"",
        //     "boxStandardName":"",
        //     "boxPrice":0,
        //     "boxTotalPrice":0,
        //     "remarks":"",
        //     "settlementWeight":1,
        //     "customerOrderId":"",
        //     "senderCompany":"",
        //     "receiverCompany":"",
        //     "checkSenderFlag":0,
        //     "checkReceiverFlag":0,
        //     "checkTransferFlag":0,
        //     "signReceipt":0,
        //     "receiptFreight":null,
        //     "receiptBusinessName":null,
        //     "receiptBusinessType":null,
        //     "packageTotalVolume":0.001,
        //     "packageChargeWeight":1,
        //     "packateVolume":0.2,
        //     "ifTransfer":0,
        //     "oldSenderCityId":"",
        //     "oldRecieverCityId":"",
        //     "productTypeWeightMin":0,
        //     "productTypeWeightMax":999999,
        //     "isUpstairs":0,
        //     "upStairsValue":0,
        //     "isElevator":0,
        //     "standardCost":13,
        //     "totalPackageVolume":0.001,
        //     "taxes":"0.00"
        // };
        const resData = await vipOrderAdd(reqData)
        console.log(resData)
        if (resData.code === RESPONSE_SUCCESS) {
          console.log(954)
          this.getOrderId = resData.data.id
          this.$message({
            message: this.$lang('下单成功！'),
            type: 'success',
          })
          if (this.printOrder) {
            const value = 'oneLinkPage'
            this.$refs.print.toPrint(value)
            this.keyBtn1 = false
          } else {
            this.keyBtn = false
          }

          // this.formData = commonFun.deepClone(this.defaultFormData)
          this.$refs.sizeForm.resetFields()
          this.checkSenderFlag = false
          this.checkReceiverFlag = false
          // 寄件人默认信息
          this.getDefaultAddress({ type: 1 })
          // 收件人默认信息
          this.getDefaultAddress({ type: 2 })
          this.countParams = ''
          this.formData.totalPackageVolume = 0
          this.formData.packageTotalVolume = 0
          this.formData.packateVolume = 0
          this.formData.packageChargeWeight = 1
          this.formData.ifTransfer = 0
          this.formData.transferName = ''
          this.formData.transferMobilePhone = ''
          this.formData.transferProvinceId = ''
          this.formData.transferProvinceName = ''
          this.formData.transferCityId = ''
          this.formData.transferCityName = ''
          this.formData.transferAreaId = ''
          this.formData.transferAreaName = ''
          this.formData.transferProvince = ''
          this.formData.transferDetailedAddress = ''
          this.formData.transferCompany = ''
          this.$router.push({ path: 'redirect/singleOrder' })
          // 实时获取是否强制保价
          this.getInsuranceFlag()
        } else if (resData.code === 149010023) {
          this.$message.warning(resData.msg)
          this.formData.senderProvinceId = '' // 收件省份id,
          this.formData.senderProvinceName = '' // 收件省份名称,
          this.formData.senderCityId = '' // 收件城市id,
          this.formData.senderCityName = '' // 收件城市名称,
          this.formData.senderAreaId = '' // 收件区域id,
          this.formData.senderAreaName = '' // 收件区域名称,
          this.formData.senderProvince = '' // 收件区省/市/区
          this.formData.senderProvince = ''
          this.keyBtn = false
        } else if (resData.code === 149010024) {
          this.$message.warning(resData.msg)
          this.formData.receiverProvinceId = '' // 收件省份id,
          this.formData.receiverProvinceName = '' // 收件省份名称,
          this.formData.receiverCityId = '' // 收件城市id,
          this.formData.receiverCityName = '' // 收件城市名称,
          this.formData.receiverAreaId = '' // 收件区域id,
          this.formData.receiverAreaName = '' // 收件区域名称,
          this.formData.receiverProvince = '' // 收件区省/市/区
          this.keyBtn = false
        } else if (resData.code === 121003009) {
          this.$message({
            message: this.$lang('面单库存不足，下单失败！'),
            type: 'error',
          })
        } else {
          this.$message.error(resData.msg)
          this.keyBtn = false
        }
      } catch (error) {
        this.keyBtn1 = false
        this.keyBtn = false
      }
    },
    // 运费计算
    async getComCost(number, startAddressId, endAddressId, paymentModeId) {
      let smModeType = 2
      if (paymentModeId) {
        switch (paymentModeId) {
          case 7:
            smModeType = 2
            break
          case 8:
            smModeType = 3
            break
          case 6:
            smModeType = 1
            break
        }
      }
      const reqData = { startAddressId, endAddressId, number, ...{ smMode: smModeType } }
      const { data = 0 } = await getComCost(reqData)
      return data || 0
    },
    // 保价费计算
    async getComputationCost(param) {
      // 参数
      const params = {
        // 保价金额
        value: param.declaredValue,
        // 物品类型code
        goodsTypeCode: param.goods.code,
        standardCost: param.standardCost,
      }
      // 调用接口
      const { data } = await getComputationCost(params)
      return data || 0
    },
    // 通过省市区匹配结算目的地(目的区域)
    async getSettlement(providerId, cityId, areaId, packageTotalWeight, type) {
      const reqData = { providerId, cityId, areaId }
      const { code, data } = await getSettlement(reqData)
      if (code === RESPONSE_SUCCESS && data) {
        const id = data.id
        return id
      } else {
        return ''
      }
    },
    // 城市重新赋值
    handleProvice(row, type) {
      console.log('城市重新')
      const { townshipId, townshipName, areaId, areaName, cityId, cityName, provinceId, provinceName } = row
      if (type === 1) {
        const defaultData = {}
        defaultData.senderProvinceId = provinceId
        defaultData.senderProvinceName = provinceName
        defaultData.senderCityId = cityId
        defaultData.senderCityName = cityName
        defaultData.senderAreaId = areaId
        defaultData.senderAreaName = areaName
        // defaultData.senderTownshipId = townshipId
        // defaultData.senderTownshipName = townshipName
        Object.assign(this.sendAddressData, { defaultData })
      } else if (type === 3) {
        const defaultData = {}
        defaultData.transferProvinceId = provinceId
        defaultData.transferProvinceName = provinceName
        defaultData.transferCityId = cityId
        defaultData.transferCityName = cityName
        defaultData.transferAreaId = areaId
        defaultData.transferAreaName = areaName
        // defaultData.transferTownshipId = townshipId
        // defaultData.transferTownshipName = townshipName
        Object.assign(this.transferData, { defaultData })
      } else {
        const defaultData = {}
        defaultData.receiverProvinceId = provinceId
        defaultData.receiverProvinceName = provinceName
        defaultData.receiverCityId = cityId
        defaultData.receiverCityName = cityName
        defaultData.receiverAreaId = areaId
        defaultData.receiverAreaName = areaName
        // defaultData.receiverTownshipId = townshipId
        // defaultData.receiverTownshipName = townshipName
        Object.assign(this.receiverAddressData, { defaultData })
      }
    },
    // 收件人姓名模糊搜索
    async remoteReceiverName(queryString, cb) {
      this.loading = true
      const param = {
        current: 1,
        size: 100,
        type: 2,
        keyword: queryString,
      }
      const { data, msg, code } = await reqAddressList(param)
      if (code === RESPONSE_SUCCESS) {
        this.loading = false
        const diseaseList = data.records
        const results = queryString ? diseaseList.filter(this.createFilter(queryString, 'name')) : diseaseList
        // 调用 callback 返回建议列表的数据
        cb(results)
        // cb(data.records)
      } else {
        cb([])
        this.$message.error(msg)
        this.loading = false
      }
    },
    // 收件人联系电话模糊搜索
    async remoteReceiverMobilePhone(queryString, cb) {
      this.loading = true
      const param = {
        current: 1,
        size: 100,
        type: 2,
        keyword: queryString,
      }
      const { data, msg, code } = await reqAddressList(param)
      if (code === RESPONSE_SUCCESS) {
        this.loading = false
        const diseaseList = data.records
        const results = queryString ? diseaseList.filter(this.createFilter(queryString, 'mobile')) : diseaseList
        // 调用 callback 返回建议列表的数据
        cb(results)
        // cb(data.records)
      } else {
        cb([])
        this.$message.error(this.$lang(msg))
        this.loading = false
      }
    },
    // 寄件人姓名模糊搜索
    async remoteSenderName(queryString, cb) {
      this.loading = true
      const param = {
        current: 1,
        size: 100,
        type: 1,
        keyword: queryString,
      }
      const { data, msg, code } = await reqAddressList(param)
      if (code === RESPONSE_SUCCESS) {
        this.loading = false
        const diseaseList = data.records
        const results = queryString ? diseaseList.filter(this.createFilter(queryString, 'name')) : diseaseList
        // 调用 callback 返回建议列表的数据
        cb(results)
        // cb(data.records)
      } else {
        cb([])
        this.$message.error(this.$lang(msg))
        this.loading = false
      }
    },
    // 寄件人联系电话模糊搜索
    async remoteSenderMobilePhone(queryString, cb) {
      this.loading = true
      const param = {
        current: 1,
        size: 100,
        type: 1,
        keyword: queryString,
      }
      const { data, msg, code } = await reqAddressList(param)
      if (code === RESPONSE_SUCCESS) {
        this.loading = false
        const diseaseList = data.records
        const results = queryString ? diseaseList.filter(this.createFilter(queryString, 'mobile')) : diseaseList
        // 调用 callback 返回建议列表的数据
        cb(results)
        // cb(data.records)
      } else {
        cb([])
        this.$message.error(this.$lang(msg))
        this.loading = false
      }
    },

    // 寄件人姓名模糊搜索
    async remoteTransferName(queryString, cb) {
      this.loading = true
      const param = {
        current: 1,
        size: 100,
        type: 3,
        keyword: queryString,
      }
      const { data, msg, code } = await reqAddressList(param)
      if (code === RESPONSE_SUCCESS) {
        this.loading = false
        const diseaseList = data.records
        const results = queryString ? diseaseList.filter(this.createFilter(queryString, 'name')) : diseaseList
        // 调用 callback 返回建议列表的数据
        cb(results)
        // cb(data.records)
      } else {
        cb([])
        this.$message.error(this.$lang(msg))
        this.loading = false
      }
    },

    createFilter(queryString, type) {
      return (disease) => {
        return (
          disease[type].toLowerCase().indexOf(queryString.toLowerCase()) !== -1 // 改为===0 就是筛选的数据只是首字匹配的列表项，需要包含输入字的所有列表项改为！==-1
        )
      }
    },
    // 实时获取是否强制保价
    async getInsuranceFlag() {
      const params = {
        id: this.userInfo.id,
      }
      const { data, msg, code } = await getInsuranceFlag(params)
      if (code === RESPONSE_SUCCESS) {
        if (data === 1) {
          // 是否保价1是，0否,
          this.insuranceFlag = 1
          this.formData.insured = 1
          this.rules.declaredValue = [RULES.required, RULES.declaredValue]
        }
      } else {
        this.$message.error(this.$lang(msg))
      }
    },

    /**
     * @description 获取回单金额
     */
    async getReceiptFee() {
      const params = {
        customerCode: this.userInfo.customerCode,
      }
      const { data, msg, code } = await getReceiptFee(params)
      if (code === RESPONSE_SUCCESS) {
        this.receiptFreight = data
        this.formData.receiptFreight = this.receiptFreight
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    /**
     * @description 获取所有类型的预估时间
     */
    async getAging() {
      const { receiverProvince, senderProvince, expressType } = this.formData
      if (receiverProvince && senderProvince) {
        const params = {
          sendProvinceId: senderProvince.senderProvinceId,
          sendCityId: senderProvince.senderCityId,
          dispatchProvinceId: receiverProvince.receiverProvinceId,
          dispatchCityId: receiverProvince.receiverCityId,
        }
        const { code, data, msg } = await getAging(params)
        if (code === RESPONSE_SUCCESS) {
          this.expressTypeList = data
          if (expressType) {
            this.expressTypeChange(expressType)
          }
        } else {
          this.$message.error(this.$lang(msg))
        }
      } else {
        this.expressTypeList = []
        this.estimatedTime = ''
      }
    },
    /**
     * @description 预估时间
     */
    async expressTypeChange(val) {
      const arr = this.expressTypeList.filter((item) => item.code === val.code)
      let obj = {}
      obj = this.appProductTypeVOList.find((item) => {
        return item.code === val
      })
      this.formData.expressTypeCode = val
      this.formData.expressTypeName = obj.name
      this.formData.productTypeWeightMin = obj.productTypeWeightMin
      this.formData.productTypeWeightMax = obj.productTypeWeightMax
      if (arr && arr.length > 0) {
        this.estimatedTime = arr[0].estimateTime
      } else {
        this.estimatedTime = ''
      }
      await this.countWeightTotal()
      if (
        this.formData.packageChargeWeight !== null &&
        (this.formData.packageChargeWeight < this.formData.productTypeWeightMin || this.formData.packageChargeWeight > this.formData.productTypeWeightMax)
      ) {
        this.$message.error(this.$lang('当前计费重量不支持选择此快递类型，请调整货物重量或者体积'))
      }
      this.getupStairsValue()
    },
    async getProductType() {
      this.appProductTypeVOList = []
      if (this.formData.senderCityId === '' || this.formData.receiverCityId === '') {
        this.$message.error(this.$lang('请先填写寄件以及收件地址'))
        this.formData.expressType = ''
        return
      }
      if (this.formData.oldSenderCityId !== this.formData.senderCityId || this.formData.oldRecieverCityId !== this.formData.receiverCityId) {
        const param = {
          sendCityId: this.formData.senderCityId,
          dispatchCityId: this.formData.receiverCityId,
          // //模拟数据
          // sendCityId: '1001000',
          // dispatchCityId: '1001090',
        }
        const { data, code } = await getProductTypeList(param)
        if (code === RESPONSE_SUCCESS) {
          this.appProductTypeVOList = data
        }
      }
    },
    // 保价费计算方法
    async calcInsuredCost() {
      // 先比较最新标准金额和上一次保存的标准金额是否相等，相等不去执行运费
      if (this.prevStandardCost != -1 && this.prevStandardCost == this.formData.standardCost) {
        return false
      }
      this.prevStandardCost = this.formData.standardCost
      const { declaredValue, goods, insured } = this.formData
      if (insured === 1 && goods && parseFloat(declaredValue) > 0) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
        this.prevStandardCost = -1
      }
    },
    // 监听省市区值变化
    changeValue(data) {
      if (data && data.transferPostalCode) {
        this.formData.transferPostalCode = data.transferPostalCode
      }
      this.calcStandardCost(this.formData)
    },
    receiverchangeValue(data) {
      debugger
      if (data && data.receiverPostalCode) {
        this.formData.receiverPostalCode = data.receiverPostalCode
      }
      this.formData.receiverCityId = ''
      this.calcStandardCost(this.formData)
      if(data&&data.receiverAreaId){
        this.verifyCollectionfee()
      }else{
        this.showCollectionfee=false
        this.formData.isCollectionfee=0
        this.formData.collectionfee=0.00
        this.formData.collectionfeeTax=0.00
      }
    },
    senderchangeValue(data) {
      if (data && data.senderPostalCode) {
        this.formData.senderPostalCode = data.senderPostalCode
      }
      this.formData.senderCityId = ''
      this.calcStandardCost(this.formData)
    },
    // 客户资料查询
    async getCustomerInfo() {
      const { data } = await customerInfo()
      console.log('getCustomerInfo...............', data)

      this.isReceiptFlag = data.isReceiptFlag

      this.formData.signReceipt = data.isReceiptFlag
      //如客户未开启回单或未维护【回单费】则前端默认写死，现改为客户未开启回单或未维护【回单费】则调财务接口获取
      this.receiptFreight = data.receiptFee
      this.formData.receiptFreight = data.receiptFee
      this.receiptBusinessName = data.receiptBusinessName
      this.formData.receiptBusinessName = data.receiptBusinessName
      this.receiptBusinessType = data.receiptBusinessType
      this.formData.receiptBusinessType = data.receiptBusinessType
      // if (!this.receiptFreight) {
      //   this.calFeeReceipt()
      // }
      this.settlementId=data.settlementId
      debugger
      if(this.settlementId&&this.settlementId==319){
        this.formData.paymentModeCode='PP_PM'
        this.formData.paymentModeId='7'
        this.formData.paymentModeName='PP_PM'
        this.formData.payment={code: "PP_PM", name: "Bulanan", id: 7, type: "ZD106"}
      }
    },
    //改为客户未开启回单或未维护【回单费】则调财务接口获取
    async calFeeReceipt() {
      const now = new Date()
      const params = {
        useNetworkId: this.userInfo && this.userInfo.networkCode ? this.userInfo.networkCode : '',
        businessType: 2, //写死2 都是电子回单
        dateTime: dayjs(now).format('YYYY-MM-DD HH:mm:ss'), // 当前时间
      }
      const { data } = await calFeeReceipt(params)

      this.receiptFreight = data && data.receiveFeeCost ? data.receiveFeeCost : 0
      this.formData.receiptFreight = data && data.receiveFeeCost ? data.receiveFeeCost : 0
    },
    // 通过邮编改变省市区
    async changeAddress(zipCode, type) {
      if (zipCode.length !== 5 && zipCode.length !== 0) return
      const { code, msg, data } = await Api.GET_QUERY_AREA({ current: 1, size: 9999, zipcode: zipCode })
      if (code === RESPONSE_SUCCESS) {
        const records = data.filter((item) => item.type === 4 || item.type === 5)
        if (records.length > 0) {
          if (type === 1) {
            this.$refs.senderProvinceSearch.selectSearchClick(records[0])
          } else if (type === 2) {
            this.$refs.receiverProvinceSearch.selectSearchClick(records[0])
          } else {
            this.$refs.transferProvinceSearch.selectSearchClick(records[0])
          }
        }
      } else {
        this.$message.warning(msg)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.bc-bottom {
  margin: 20px 0;
  text-align: center;
}

.singleOrder {
  padding: 0 24px;

  h3 {
    font-size: 20px;
  }

  .width100 {
    width: 100%;
  }

  .w360 {
    width: 100%;

    .el-input {
      width: 360px !important;
    }
  }

  .w180 {
    // width: calc(20% + 160px);
    width: 400px;

    .el-input {
      width: 360px !important;
    }
  }

  .w160 {
    width: 400px;

    .custom-province {
      display: inline-block;
    }

    ::v-deep.el-select,
    .el-input {
      width: 360px !important;
    }
  }

  .tooltip-click {
    margin-left: 5px;
    width: 18px;
    height: 18px;
    background: #197d3b;
    color: #fff;
    border-radius: 18px;
    text-align: center;
    line-height: 18px;
    display: inline-block;
  }
}

.group-title {
  border-bottom: 1px dashed #eeeeee;
  // margin-bottom: 20px;
  margin: 0 10px 20px 10px;
  padding: 16px 0px;

  .title {
    font-size: 14px;
    color: #333;
    font-weight: 600;
    display: inline-block;
    line-height: 7px;
    border-bottom: 4px solid #e0bd7b;
  }

  .insert-info {
    display: inline-block;
    margin-left: 60px;
    position: relative;

    .icon {
      color: #e0bd7b;
      position: absolute;
      overflow: visible;
    }

    .text {
      color: #666666;
      margin-left: 20px;
    }
  }
}

.group-content {
  background: #f7f7f9;
  padding: 20px 20px 0px;
  border-radius: 8px;

  .el-textarea__inner {
    min-height: 60px;
  }

  .oper {
    position: absolute;
    right: 20px;
    bottom: 5px;
    cursor: pointer;
    color: #333;

    .red {
      color: red;
      margin-right: 20px;
    }
  }

  .estimated-time {
    padding: 10px 0;
    text-align: center;
    color: red;
    font-size: 16px;
  }
}
</style>
<style lang="scss">
.el-form.el-form-edit .el-form-item.insured-info .el-form-item__content {
  position: relative;

  .btn-insured {
    color: #e60012;
    font-size: 12px;
    cursor: pointer;
    position: absolute;
    top: 34px;
    display: inline-block;
    height: 22px;
    line-height: 16px;
    left: 10px;

    &:hover {
      text-decoration: underline;
    }
  }
}

.el-form-item.declaredValue {
  .el-input-number .el-input__inner {
    text-align: left;
  }
}

.singleOrder {
  .el-form-item__label {
    width: 180px !important;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
</style>
